import * as React from 'react';
import { DataTable } from 'damco-components';

interface IProps {
    data: any[];
    distributionType:number;
    cols: any[];
    isEditable:boolean;
    isSelectable:boolean;
    subTableRef:any;
    targetLevel: number;
    onchange: (value:boolean, list:any[]) => void
}
interface IState {
    isSelectable:boolean,
    selectedList: boolean[]
}
export class DialogSubTableWrapper extends React.Component<IProps, IState> {
    public myTable:any = React.createRef<HTMLDivElement>();
    public state = {
        isSelectable: false,
        selectedList: []
    }
    constructor(props:IProps) {
        super(props)
    }
    public componentDidMount (){
        if(this.myTable.current && this.props.subTableRef.current){
            this.myTable.current.addEventListener('click', this.clickEventHandler)
        }
    }
    public componentWillUnmount(){
        this.myTable.current.removeEventListener('click', this.clickEventHandler)
    }
    public componentDidUpdate (props:IProps, state:IState){
        if(props.isSelectable !== this.props.isSelectable){
            this.isSelectable()
        }
    }
    public isSelectable = ():boolean =>{
        if(this.props.isSelectable && this.props.distributionType){
            this.props.subTableRef.current.toggleSelectAll()
            this.props.onchange(true, [])
            this.selectChildren(this.props.distributionType)
        }
        return this.props.isSelectable
    }
    public selectedList = () =>{
        const list = this.myTable.current.querySelectorAll('input.checkbox.grid-checkbox');
        const dataList = (this.props.subTableRef.current.getData())
        const arrResp:any[] = [];
        dataList.forEach((el:any, index:number) =>{
            arrResp.push(list[index+1].checked)
        })
        return arrResp
    }
    public clickEventHandler = (ev:any) => {
        if (ev.target.matches('input.checkbox.grid-checkbox')) {
            if(ev.target.parentNode.matches('div.rt-resizable-header-content')){
                this.props.onchange(ev.target.checked, [])
            }else{
                this.props.onchange(ev.target.checked, this.selectedList())
            }
        }
    }
    public selectChildren = (target:number) => {
        const list = this.myTable.current.querySelectorAll('.button-group button');
        list.forEach((btn:any,index:number)=>{
            btn.classList.remove('-selected')
        })
        if(list && list.length > 0){
        switch(target){
            case 1:
                list[1].classList.add('-selected')
            break
            case 2:
                list[0].classList.add('-selected')
            break;
            case 3:
                list[2].classList.add('-selected')
            break;
        }
        }
    }
    public render() {
        if(this.props.data && this.props.targetLevel){
        return(
            <div ref={this.myTable}>
            <DataTable
                id={`CostAndRevSubTable`}
                data={this.props.data} 
                columns={this.props.cols}
                isEditable={this.props.isEditable}
                isSelectable={this.props.isSelectable}
                selectedOption="multiple"
                isSortable={true}
                isExpandable={false}
                isResizable={true}
                hasFooter={false}
                ref={this.props.subTableRef}
                actions={null}
                showColumnOptions={false}
                defaultPageSize={100}
                tableName={`CostAndRevSubTable`}
                showPagination={this.props.data.length && this.props.data.length> 100? true: false}
            />
            </div>
        )
        }else{
            return <div/>
        }
    }
    
}